export const baseEvent = {
  context: 'PROP_RENTAL',
} as const
